import * as React from 'react';
import { connect } from 'react-redux';
import { SurveyComplete } from '../../components/pages/SurveyComplete';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators } from '../../store/SurveyBuilderStore';
import { SurveyCompletePageStateSetter } from '../state-setter/SurveyCompletePageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const SurveyCompleteContainer: React.ComponentType<any> = connect((state: IApplicationState) => ({ ...state.surveyBuilder }), {
	...ActionCreators,
	...NavigationActions,
})(SurveyComplete);

export class SurveyCompletePage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<SurveyCompleteContainer {...this.props} />
				<SurveyCompletePageStateSetter {...this.props} />
			</>
		);
	}
}
